import React, {Component} from 'react';
import Order from "./components/Order";
import Footer from "./components/Footer";
import Receipt from "./components/Receipt";
import Description from "./components/Description";
import axios from 'axios';
import Login from "./components/Login";

class App extends Component {
	state = {
		success: false,
		customer: {},
		product: {},
		initialized: false,
		authenticated: false,
		authError: null,
		orderError: null,
		customerDetail: {}
	}

	dummyData = async () => {
		await axios.get(this.getApiUrl('user/dummy-data'))
			.then(response => response.data)
			.then(profile => {
				profile.ccNumber = profile.testCC;
				profile.expyear = new Date().getFullYear() + 1;
				profile.expmonth = 1;
				this.setState({customer: {profile}})
			});
	}

	getApiUrl = (path) => {
		const loc = window.location;
		return `${loc.protocol}//${loc.hostname}/api2/${path}`;
	}

	getProductId = () => {
		return window.location.pathname.split('/').pop();
	}

	componentDidMount() {
		const product = this.getProductId();

		axios.get(this.getApiUrl(`order/product/${product}`))
			.then(response => response.data)
			.then(product => this.setState({product, initialized: true}));
	}

	orderSubmit = async values => {
		this.setState({orderError: null});

		await axios.post(this.getApiUrl('order/charge'), {product: this.state.product, payment: values})
			.then(response => response.data).then(data => {
				if (data.success) {
					this.setState({success: true,customerDetail:data.customer});
				} else {
					this.setState({orderError: data.error});
				}
			});
	}

	login = async values => {
		this.setState({authError: null});

		values.product_id = this.getProductId();
		await axios.post(this.getApiUrl('order/login'), values)
			.then(response => response.data)
			.then(data => {
				if (data.success) {
					this.setState({
						authenticated: true,
						customer: data.customer
					})
				} else {
					this.setState({authError: data.error});
				}
			});
	}

	render() {
		const receipt = this.state.success ? <Receipt customerDetail={this.state.customerDetail} product={this.state.product}/> : null;
		const forms = this.state.initialized && !this.state.success ? (
			<div>
				<Login onSubmit={this.login} authError={this.state.authError} authenticated={this.state.authenticated}/>
				<Order order={this.orderSubmit} orderError={this.state.orderError} customer={this.state.customer}/>
			</div>
		) : null;
		const footer = this.state.initialized ? <Footer/> : null;

		return (
			<div>
				<section>
					<div className="container">
						<h2 onClick={this.dummyData}>Order Form</h2>
						<Description product={this.state.product} initialized={this.state.initialized}/>
						{forms}
						{receipt}
					</div>
				</section>
				{footer}
			</div>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js